import { openProtectedFile } from '../../utils/protectedFile';
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector } from 'react-redux';
import { Image, Modal, Alert } from 'react-bootstrap';
import doctorIcon from '../../assets/Images/doctorIcon.png';
import {useAlert} from 'react-alert';
import { uploadFileError, UPLOAD_ACCEPT } from '../../utils/uploadLimits';
import { Formik, Form } from 'formik';
import { submitCCMCareplan, getPatientCCMCareplan, deleteCCMCareplan } from '../../actions/HRActions';
import NotFound from '../../components/NotFound';
import { Prod01 } from '../../constants/ActionType';
import { formatDateTime } from '../../utils/dateFormat';

// import { CCM_CAREPLAN_RESET } from '../../constants/HRConstants';


const PatientCareplans = ({ patientId }) => {
  const alert = useAlert();
  const dispatch = useDispatch();

  const [carePlanShow ,setCarePlanShow] = useState(false);
  const [fileName, setFileName] = useState({});
  const [fileError, setFileError] = useState('');
  const [description, setDescription] = useState('');
  const [error, setError] = useState('');
  
  // const {error : commonError, message} = useSelector(state => state.common);
  const { ccmCareplan } = useSelector(state => state.patientCCMCareplan);
  const { user } = useSelector(state => state.auth);

  const downloadFile = (fileName) => {
    // local link
    // window.open(`http://localhost:5000/v1/uploadFiles/${fileName}`);
    // live link
    openProtectedFile(fileName);
  }

  const handleCarePlanModalClose = () => setCarePlanShow(false);
  const handleCarePlanModalShow = () => setCarePlanShow(true);

  useEffect(() => {
    // if(commonError) {
    //   alert.error(commonError);
    //   dispatch({ type: CCM_CAREPLAN_RESET})
    // }

    // if(message){
    //   alert.success(message);
    //   dispatch({ type: CCM_CAREPLAN_RESET})
    // }

    dispatch(getPatientCCMCareplan(patientId));

    },[dispatch]);


  const handleFileChange = e => {
    const file = e.target.files[0];
    const problem = uploadFileError(file);
    setFileError(problem || '');
    if (problem) {
      e.target.value = '';
      setFileName({});
      return;
    }
    setFileName(file || {});
  }

  const submitCarePlan = () => {
    if(description === '' && fileName.name === undefined){
      setError('description and file required.');
      return;
    }

    if(error !== '' || error !== undefined){
      setCarePlanShow(true);
    }

    dispatch(submitCCMCareplan(fileName, user, patientId, description));
      setFileName({});
       setError('');
       setCarePlanShow(false);
  }

  const deleteHandler = (careplanId) => {
    var confirmation = window.confirm(`Are you sure you want to delete patient CCM careplan ?`);
        if(confirmation){
          dispatch(deleteCCMCareplan(careplanId));
        }
    }

  return (
    <div>
          <h5 className='title'>CCM Careplan</h5>
               

        {ccmCareplan ? <>
          <div className="row">
            <button className="btn link" onClick={() => downloadFile(ccmCareplan?.fileName)}>
              {ccmCareplan?.fileName}
            </button>
          </div>
        
          <p>
            <small>{ccmCareplan?.description}</small>
          </p>
         
          <div className="row-display-secondary">
            <div>
              <Image src={doctorIcon} style={{width: '60px', height: '60px'}} />
            </div>

             <div className="pl-2 m-2">
                <b>{ccmCareplan?.addedBy}</b>
                <p className='text-muted'>{formatDateTime(ccmCareplan?.createdAt)}</p>
             </div> 
          </div>        
        </> :  <div className="text-center">
          <br />
          <NotFound title="CCM Careplan Not Added" />
        </div> }

        {ccmCareplan ? <div className='text-center'>
          <button className="edit-pill" onClick={() => deleteHandler(ccmCareplan?._id)}>
                <i className="bx bx-minus mr-2"></i> Delete
              </button> 
        </div> : null}

     
        
          

        {!ccmCareplan ? <div className="text-center">
          <button className="edit-pill" onClick={handleCarePlanModalShow}> 
            <i className="bx bx-plus-medical"></i> Add
          </button> 
        </div> : null}    
        
        

          {/* Add CCM Careplan Modal */}
          <Modal show={carePlanShow} onHide={handleCarePlanModalClose}>
            <Modal.Header >
                <h5>
                  Add CCM Careplan
                </h5> 
                <button onClick={handleCarePlanModalClose} className="btn btn-danger">
                  <i className='bx bx-x'></i>
                </button>
            </Modal.Header>

                <Modal.Body>
                    <Formik initialValues={{
                        description: '', 
                        fileName: ''
                    }}
                    onSubmit={() => {submitCarePlan()}}>
                        <div>
                          {error && <>
                            <Alert key="danger" variant="danger">
                              {error}
                            </Alert>
                          </>}
                          

                            <Form>                       
                            <label htmlFor="description" className="form-label mt-3">Description</label>
                                <textarea 
                                    label="Description" 
                                    name="description"
                                    className="form-control"
                                    rows="4"	
                                    value={description} 
                                    onChange={(e) => setDescription(e.target.value)}
                                    placeholder="Type description here .... "
                                />
                                
                                <br />
                            <label htmlFor="description" className="form-label mt-3">Attachment</label>
                                <input 
                                    label="File" 
                                    name="fileName" 
                                    type="file"
                                    accept={UPLOAD_ACCEPT}
                                    className="form-control"
                                    style={{border: 'none'}} 
                                    onChange={handleFileChange}
                                />
                                {fileError && <small className="text-danger d-block">{fileError}</small>}
                            <br/>
                            <div className="row-class" style={{justifyContent: 'space-between'}}>
                                <button className="btn btn-outline-primary btn-sm" type="submit"> Save Careplan</button>
                            </div>
                            </Form>
                        </div>
                    
                    </Formik>   
                </Modal.Body>
            </Modal>
    </div>
  )
}

export default PatientCareplans